import { View } from 'react-native';
import { Divider, useTheme } from '@ui-kitten/components';

import ListItemLoader from '../../Components/ListItemLoader';
import { RectangleLoader } from '../../Components/Loader';
import {
  ids as reservationStyleIds,
  styles as reservationStyles,
} from '../../Components/Reservation/styles';
import ResponsiveLayout from '../../Components/ScreenWrapper/ResponsiveLayout';
import constants from '../../Config/constants';
import themeStyle from '../../Theme/styles';

import MapsAndInfoLoader from './components/MapAndInfoLoader';
import ReservationsLoader from './ReservationsLoader';
import StoreTagsLoader from './StoreTagsLoader';
import {
  ids as reservationStoreStyleIds,
  styles as reservationStoreStyles,
} from './styles';

const PageLoader = () => {
  const theme = useTheme();

  return (
    <ResponsiveLayout
      LeftComponent={
        <View style={themeStyle.flex1}>
          <View style={reservationStoreStyles.bannerContainer}>
            {/* Screen Banner */}
            <RectangleLoader height={constants.isWeb ? 310 : 230} />
          </View>
          <View style={reservationStyles.contentContainer}>
            <View
              dataSet={{ media: reservationStoreStyleIds.detailsContainer }}
              style={reservationStoreStyles.detailsContainer}
            >
              {/* Store Name */}
              <View style={themeStyle.spacingBottomSmall}>
                <RectangleLoader height={54} />
              </View>
              {/* Store Tags */}
              <StoreTagsLoader
                category="h6"
                containerStyle={themeStyle.spacingBottom}
              />
              {/* Description */}
              <View style={themeStyle.spacingBottom}>
                <RectangleLoader height={120} />
              </View>
              {/* Dress Code */}
              <RectangleLoader width={150} height={32.5} />
              <View style={[{ width: '30%' }, themeStyle.spacingTopSmall]}>
                <ListItemLoader
                  contentContainerStyle={themeStyle.spacingBottom}
                  withLeftIcon
                />
              </View>
              <View
                style={[
                  themeStyle.pageVerticalSpacingMedium,
                  themeStyle.pageHorizontalSpacingSmall,
                  reservationStoreStyles.borderRadius,
                  { backgroundColor: theme['color-control-active'] },
                ]}
              >
                <ListItemLoader textSize={76.5} withLeftIcon />
              </View>
            </View>
            <Divider
              dataSet={{ media: reservationStyleIds.sectionDivider }}
              style={[
                themeStyle.spacingTop,
                themeStyle.spacingBottomMedium,
                themeStyle.sectionSeparator,
                reservationStyles.sectionDivider,
              ]}
            />
            <ReservationsLoader />
            <Divider
              dataSet={{ media: reservationStyleIds.sectionDivider }}
              style={[
                themeStyle.sectionSeparator,
                reservationStyles.sectionDivider,
              ]}
            />
            <MapsAndInfoLoader />
          </View>
        </View>
      }
      RightComponent={
        <View
          dataSet={{ media: reservationStyleIds.boxWrapperWeb }}
          style={reservationStyles.boxWrapperWeb}
        >
          <View
            dataSet={{ media: reservationStyleIds.boxContainer }}
            style={reservationStyles.boxContainer}
          >
            <View
              dataSet={{ media: reservationStyleIds.box }}
              style={reservationStyles.box}
            >
              <View style={themeStyle.spacingBottomMedium}>
                <RectangleLoader height={162} />
              </View>
              <RectangleLoader height={49} />
            </View>
          </View>
        </View>
      }
      backgroundColor={null} // to remove safearea on the top
      rightComponentWidth={285}
    />
  );
};

export default PageLoader;
